import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { locale: String }

  connect() {
    window.i18n.locale = this.localeValue
  }
}
